import { Pipe, PipeTransform } from '@angular/core';
import { BonCommande } from '../../models/bonCommande';

@Pipe({
	name: 'filterBonCommandeByNumero'
})
export class FilterBonCommandeByNumeroPipe implements PipeTransform {
	transform(bonCommandes: BonCommande[], filter: string): BonCommande[] {
		if (
			!bonCommandes ||
			!filter ||
			bonCommandes === null ||
			filter === null ||
			filter === ''
		) {
			return bonCommandes;
		}

		const lowerFilter = filter.toLowerCase();

		return bonCommandes.filter((b: BonCommande) => {
			const numero = b.commande?.toLowerCase() || '';
			const lot = b.lot?.toLowerCase() || '';
			const marche = b.marche?.toLowerCase() || '';

			return (
				numero.includes(lowerFilter) ||
				lot.includes(lowerFilter) ||
				marche.includes(lowerFilter)
			);
		});
	}
}
